import { useEffect, useState } from "react";
import {
  getPaginatedValidationErrorsList,
  getPaginatedValidationErrorsListWithoutIssue,
} from "../services/resourcesService";
import { validationErrorsMockData } from "../services/constants/resource";

interface IuseFetchPaginatedValidationErrors {
  currentValidationResultId: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  pSize: number;
  isDetailedExecutionDataAvailable: boolean;
  isIssuesDataAvailable: boolean;
  selectedColumnName: string;
}

const useFetchPaginatedValidationErrors = ({
  currentValidationResultId,
  setIsLoading,
  page,
  pSize,
  isDetailedExecutionDataAvailable,
  isIssuesDataAvailable,
  selectedColumnName,
}: IuseFetchPaginatedValidationErrors) => {
  const [validationErrors, setValidationErrors] = useState<any>([]);
  useEffect(() => {
    const fetchValidationErrors = async () => {
      setIsLoading(true);

      try {
        let result;

        // Use conditional logic based on is_issues_data_available flag
        if (isIssuesDataAvailable) {
          // Use existing endpoint with issues
          result = await getPaginatedValidationErrorsList({
            currentValidationResultId,
            selectedColumnName,
            page,
            pSize,
          });
        } else {
          // Use new endpoint without issues
          result = await getPaginatedValidationErrorsListWithoutIssue({
            currentValidationResultId,
            selectedColumnName,
            page,
            pSize,
          });
        }

        //Set Mock Data
        // const result: any = validationErrorsMockData;

        setValidationErrors(result);
      } catch (err) {
        setValidationErrors([]);
      } finally {
        setIsLoading(false);
      }
    };
    if (!isDetailedExecutionDataAvailable && selectedColumnName !== "")
      fetchValidationErrors();
  }, [
    currentValidationResultId,
    page,
    pSize,
    isDetailedExecutionDataAvailable,
    isIssuesDataAvailable,
    selectedColumnName,
  ]);

  return [validationErrors];
};

export default useFetchPaginatedValidationErrors;
